import React from "react";

import { CompaniesCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function companies({ width, onResize }: Column.Options) {
	return base(ColumnId.Companies, (item) => <Content item={item} />, {
		width,
		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default companies;
